<template>
  <div class="dashboard-message">
    <div class="list-group list-group-flush">
      <div class="list-group-item">
        <strong>Message Active Times:</strong>
        {{ dashboardMessage.startDate | short_date_time_format }} - {{ dashboardMessage.endDate | short_date_time_format }}
      </div>
    </div>
    <div class="card-body">
      <p>Message Preview</p>
      <div class="alert" :class="'alert-' + dashboardMessage.type" v-html="dashboardMessage.content"></div>
    </div>
    <div class="card-footer text-right">
      <router-link class="btn btn-sm btn-warning" :to="{ path: `/membership/messages/dashboard/edit/${dashboardMessage.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button class="btn btn-sm btn-danger" @click="delMessage(dashboardMessage)">
        <span class="fa fa-trash-alt"></span> Delete
      </button>
    </div>
  </div>
</template>

<script>
import {
  DELETE_DASHBOARD_MESSAGE
} from '@/vuex/types'
import { randomLabel } from '@/util/helpers'
import { mapActions } from 'vuex'
export default {
  name: 'AccountMessage',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    dashboardMessage () {
      return {
        startDate: new Date(),
        endDate: new Date(),
        content: '',
        Organization: {},
        ...this.object
      }
    }
  },
  methods: {
    async executeAction (action, payload) {
      await this[action](payload)
    },
    delMessage (message) {
      this.executeAction(DELETE_DASHBOARD_MESSAGE, message)
    },
    randomLabel,
    ...mapActions([
      DELETE_DASHBOARD_MESSAGE
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/DashboardMessage.vue